import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material/snack-bar';
import {SnackbarComponent, SnackbarData, SnackbarStyle} from '../components/snackbar/snackbar.component';

@Injectable({providedIn: 'root'})
export class SnackbarService {
    defaultConfig: MatSnackBarConfig = {
        duration: 3_000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
    };

    constructor(private matSnackBar: MatSnackBar) {
    }

    showSnackBar(
        message: string,
        style?: SnackbarStyle,
        isInfinite: boolean = false,
        translationParams?: Record<string, any>,
    ): MatSnackBarRef<SnackbarComponent> {
        return this.open({message, style, isInfinite, translationParams});
    }

    // renders the message as markup: messageHtml and every translationParams value reach the DOM unsanitized.
    // messageHtml MUST be an i18n constant; any runtime value in translationParams MUST be escaped by the caller.
    showHtmlSnackBar(
        messageHtml: string,
        style?: SnackbarStyle,
        isInfinite: boolean = false,
        translationParams?: Record<string, any>,
        commonsClickById?: Record<string, any>,
    ): MatSnackBarRef<SnackbarComponent> {
        return this.open({messageHtml, style, isInfinite, translationParams, commonsClickById});
    }

    dismiss(): void {
        this.matSnackBar.dismiss();
    }

    private open(data: SnackbarData): MatSnackBarRef<SnackbarComponent> {
        const duration = data.isInfinite ? 0 : this.defaultConfig.duration;
        return this.matSnackBar.openFromComponent(SnackbarComponent, {...this.defaultConfig, duration, data});
    }
}
